import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  useDeleteDayoffMutation,
  useFetchDayoffListQuery,
} from "../../../store";
import { personColumns } from "../utils/personColumns";
import CustomToolbar from "./Toolbar";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeDialog,
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import { setSelectedId } from "../../../store/slices/permissionGrid/permissionGridSlice";
import {
  CONFIRM_DIALOG,
  DOCUMENT_DIALOG,
  UPDATE_DAYOFF,
} from "../../../store/slices/utils/dialogEnum";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../store/slices/toast/toastSlice";
import CustomConfirmDialog from "../../../components/shared/CustomConfirmDialog";

const PermissionGrid = () => {
  const dispatch = useDispatch();
  const { selectedId } = useSelector((state) => state.permissionGridSlice);
  const { confirmDialogOpen } = useSelector((state) => state.dialogSlice);
  const [pagination, setPagination] = React.useState({
    pageSize: 5,
    page: 0,
  });

  const { data, isLoading } = useFetchDayoffListQuery(
    {
      page: pagination.page === 0 ? 1 : pagination.page + 1,
      limit: pagination.pageSize,
    },
    { refetchOnMountOrArgChange: true }
  );

  console.log("data", data);
  const [deleteMutate, { isLoading: deleteDayoffLoading }] =
    useDeleteDayoffMutation();
  const rowCountRef = React.useRef(data?.data.totalRowCount || 0);
  const rowCount = React.useMemo(() => {
    if (data?.data.totalRowCount !== undefined) {
      rowCountRef.current = data?.data.totalRowCount;
    }
    return rowCountRef.current;
  }, [data?.data.totalRowCount]);

  const handleUpdate = (id) => {
    dispatch(setSelectedId(id));
    dispatch(openDialog(UPDATE_DAYOFF));
  };
  const handleDelete = (id) => {
    dispatch(setSelectedId(id));
    dispatch(openDialog(CONFIRM_DIALOG));
  };
  const handleDeleteClose = () => {
    dispatch(setSelectedId(null));
    dispatch(closeDialog(CONFIRM_DIALOG));
  };
  const handleDocument = (id) => {
    dispatch(setSelectedId(id));
    dispatch(openDialog(DOCUMENT_DIALOG));
  };
  const postDelete = async () => {
    var response = await deleteMutate(selectedId);
    if (!response.data.isSuccess) {
      dispatch(openErrorToast("İzin Silinemedi"));
    } else {
      dispatch(openSuccessToast("İzin Silindi"));
      dispatch(setSelectedId(null));
      dispatch(closeDialog(CONFIRM_DIALOG));
    }
  };
  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: 10,
        overflowX: "auto",
        minWidth: { xs: 600, sm: 0 },
        flex: "flex",
        flexDirection: "column",
      }}
    >
      {confirmDialogOpen && (
        <CustomConfirmDialog
          handleConfirm={postDelete}
          title="İzin Silme Onayı"
          text="Bu izni silmek istediğinize emin misiniz?"
          isLoading={deleteDayoffLoading}
          handleClose={handleDeleteClose}
        />
      )}
      <DataGrid
        rows={data?.data.dayoffs}
        rowCount={rowCount}
        loading={isLoading}
        disableColumnMenu
        columns={personColumns(handleUpdate, handleDelete, handleDocument)}
        paginationMode="server"
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        slots={{ toolbar: CustomToolbar }}
        showToolbar
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
      />
    </Box>
  );
};

export default PermissionGrid;
